var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClip = function SvgClip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.444 21.5H1.556c-.28 0-.549-.11-.747-.308A1.047 1.047 0 0 1 .5 20.45V1.55A1.058 1.058 0 0 1 1.556.5h16.888c.28 0 .549.11.747.308.198.196.309.464.309.742v18.9a1.058 1.058 0 0 1-1.056 1.05ZM4.722 4.7v4.2h4.222V4.7H4.722Zm0 6.3v2.1h10.556V11H4.722Zm0 4.2v2.1h10.556v-2.1H4.722Zm6.334-9.45v2.1h4.222v-2.1h-4.222Z",
    fill: "#E0E0E0"
  })));
};

export default SvgClip;